import { render } from "./LangComp.vue?vue&type=template&id=132f7f42&scoped=true"
import script from "./LangComp.vue?vue&type=script&lang=js"
export * from "./LangComp.vue?vue&type=script&lang=js"

import "./LangComp.vue?vue&type=style&index=0&id=132f7f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f7f42"]])

export default __exports__